import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-advanced-filter',
  templateUrl: './advanced-filter.component.html',
  styleUrls: []
})
export class AdvancedFilterComponent {
  @Input() filterType: { type: string; showDropDown: boolean, dropDownList?: { name: string, id: string }[] }[] = [];
  availableFilter: { type: string; showDropDown: boolean, dropDownList?: { name: string, id: string }[] }[] = [];

  @Output() search = new EventEmitter<{ type: string; value: string; isId?: boolean }>();
  @Output() loadMore = new EventEmitter<string>();
  @Output() searchDropDown = new EventEmitter<{ type: string, term: string }>();
  @ViewChildren('itemSelect') selects!: QueryList<NgSelectComponent>;

  private searchSubjects: { [key: string]: Subject<string> } = {};
  public searchValues: {
    [key: string]: string | undefined
  } = {};

  constructor() { }

  private initSearchSubject(type: string) {
    if (!this.searchSubjects[type]) {
      this.searchSubjects[type] = new Subject<string>();
      this.searchSubjects[type]
        .pipe(debounceTime(500), distinctUntilChanged())
        .subscribe(value => {
          this.search.emit({ type, value });
        });
    }
  }

  addFiltertype(filter: { type: string; showDropDown: boolean }) {
    if (!this.availableFilter.some(f => f.type === filter.type)) {
      this.availableFilter.push(filter);
      this.initSearchSubject(filter.type);
    }
  }

  removeFilter(type: string) {
    this.clearNgModel();
    this.availableFilter = this.availableFilter.filter(f => f.type !== type);
    this.clearSearch(type);
  }

  clearSearch(type: string) {
    this.searchSubjects[type]?.next('');
    this.searchValues[type] = undefined;
  }

  clearAllFilters() {
    this.clearNgModel();
    this.availableFilter.forEach(item => this.clearSearch(item.type));
    this.availableFilter = [];
  }

  clearNgModel() {
    this.selects.forEach((selectRef: NgSelectComponent) => {
      if (selectRef.hasOwnProperty('selectedValue')) {
        (selectRef as any).selectedValue = null;
      }
      selectRef.searchTerm = '';
      selectRef.filter('');
      selectRef.clearModel();
    });
  }

  onSearch(
    value: { id: string | number; name: string } | string | number | null | undefined,
    type: string,
    isDropDown = false
  ): void {
    if (isDropDown) {
      if (value && typeof value === 'object' && 'id' in value) {
        this.searchValues[type] = value.name.toString();
        this.searchSubjects[type]?.next(value.id.toString());
      }
    } else {
      if (value != null) {
        this.searchValues[type] = value.toString();
        this.searchSubjects[type]?.next(value.toString());
      }
    }
  }

  getFilterValue(type: string): string | undefined {
    const value = this.searchValues[type];
    if (!value) return;
    return ` ${value}`;
  }

  onClear(selectRef: any, type: string) {
    selectRef.selectedValue = null;
    selectRef.searchTerm = '';
    selectRef.filter('');
    selectRef.clearModel();
  }
}
